import React from 'react';

const PrivacyPolicyPage = () => {
  return (
    <div className="bg-gray-100 py-12">
      <div className="container mx-auto px-6 bg-white p-8 md:p-12 rounded-lg shadow-md">
        <h1 className="text-3xl md:text-4xl font-bold text-gray-800 mb-2">Privacy Policy</h1>
        <p className="text-gray-500 mb-8">Effective Date: August 2, 2025</p>

        <div className="space-y-6 text-gray-700">
          <p>This Privacy Policy describes how Syncratik ("Company," "we," "us," or "our") collects, uses, and discloses information in connection with our AI Customer Service Agent and related services (the "Service"). We are committed to protecting the privacy of our business customers and their end-users.</p>

          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-3">1. Information We Collect</h2>
            <p>We collect and process the following types of information:</p>
            <ul className="list-disc list-inside ml-4 space-y-2">
              <li><strong>Customer Data:</strong> This includes conversational data (text and audio), customer information (names, emails), and metadata (timestamps, user IDs).</li>
              <li><strong>Account and Billing Information:</strong> Your company name, contact details, and billing information needed to manage your account.</li>
              <li><strong>Usage Data:</strong> Information about how you interact with the Service, such as features used and performance metrics.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-3">2. How We Use the Information</h2>
            <p>We use the collected information to provide and improve the Service, manage your account, and for security and legal compliance. This includes using data to train and improve our AI models.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-3">3. Disclosure of Information</h2>
            <p>We do not sell or rent your information. We may share it with third-party service providers (like cloud hosting) who are contractually obligated to protect it, or if required by law.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-3">4. Data Retention</h2>
            <p>We retain Customer Data for as long as your account is active and for a reasonable period thereafter. Anonymized usage data may be retained indefinitely for analytical purposes.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-3">5. Your Choices and Rights</h2>
            <p>You have the right to access, correct, or request the deletion of your account and Customer Content. Upon request, we can also provide a copy of your Customer Content.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-3">6. Data Security</h2>
            <p>We implement reasonable technical and organizational measures to protect your information, but no method is 100% secure.</p>
          </section>
          
          <section>
             <h2 className="text-2xl font-semibold text-gray-800 mb-3">7. Changes to This Privacy Policy</h2>
             <p>We may update this policy and will notify you of material changes by posting the new policy on our website. Your continued use of the Service after changes constitutes acceptance.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-3">8. Contact Us</h2>
            <p>If you have any questions, please contact us at:</p>
            <address className="not-italic mt-2 text-gray-600">
              Syncratik<br />
              8732 Orwell Avenue<br />
              Westminster, CA 92683<br />
              Email: info@syncratik.com
            </address>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
